// Object containing all the wizard store names to access via route name
export const wizardStores: any = {
  'InstallationWizard': 'installationWizard',
  'installationWizard': 'installationWizard',
  'TenantWizard': 'tenantWizard',
  'loggerWizard': 'loggerWizard',
};
